<template>
  <el-dialog
    title="规则介绍"
    :visible.sync="dialogFormVisible"
    custom-class="custom_dialog"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="ruleForm"
          :rules="ruleFormRules"
          ref="ruleForm"
          label-width="0px"
          class="demo-ruleForm"
          size="mini"
          width="500px"
        >
          <el-form-item label="">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="ruleForm.RuleDetails"
              :autosize="{ minRows: 4, maxRows: 6 }"
              maxlength="255"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveRule('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import voteRuleApi from '../../api/vote/voteRule'
export default {
  name: 'EditRule',
  data () {
    return {
      ruleForm: {
        RuleId: null,
        RuleDetails: null
      },
      ruleFormRules: {
        RuleDetails: [
          { min: 0, max: 255, message: '介绍描述长度最多255个字符。', trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      ruleId: null
    }
  },
  props: {

  },
  methods: {
    getRuleDetails: function () {
      const _this = this
      this.openLoading()
      voteRuleApi.getRuleDetails({
        ruleId: this.ruleId
      }).then(data => {
        this.ruleForm.RuleDetails = data
        this.ruleForm.RuleId = _this.ruleId
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    saveRule: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = this.openLoading('保存中…')
          voteRuleApi.editRuleDetails(this.ruleForm).then(data => {
            openLoading.close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.dialogFormVisible = false
          }).catch(err => {
            openLoading.close()
            this.dialogFormVisible = false
            return err
          })
        } else {
          return false
        }
      })
    },
    openEditRule: function (ruleId) {
      this.dialogFormVisible = true
      this.ruleId = ruleId
      this.getRuleDetails()
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
